import { TypeOf, yup } from '@guiker/yup-util'

export const searchAllListingUnitsQueryParamsSchema = yup.object({
  searchString: yup.string(),
  includeAll: yup.boolean(),
})

export type SearchAllListingUnitsQueryParamsSchema = TypeOf<typeof searchAllListingUnitsQueryParamsSchema>
